<template>
  <div class="donation">
    <div class="row">
      <div class="col-6">
        <p class="info d-none d-sm-flex">
          <span class="donation-avatar">{{
            donation.nameofdonor | getInitials
          }}</span>
          <span class="donation-details">
            <span class="donation-author text-ellipse">{{
              donation.nameofdonor
            }}</span>
            <span
              class="donation-organization text-ellipse"
              :title="
                getOrganizationNameFromId(donation.donationorganizationid)
              "
              >{{
                getOrganizationNameFromId(donation.donationorganizationid)
              }}</span
            >
          </span>
        </p>

        <div class="d-block d-sm-none text-left">
          <h5
            class="donation-author text-ellipse"
            :title="getOrganizationNameFromId(donation.donationorganizationid)"
          >
            {{ donation.nameofdonor }}
          </h5>
          <p class="donation-organization text-ellipse">
            {{ getOrganizationNameFromId(donation.donationorganizationid) }}
          </p>
        </div>
      </div>

      <div class="col-6">
        <p class="donation-amount">
          <span class="currency text-ellipse" :title="donation.amount">₦</span>
          {{ donation.amount | newAmountFormatter }}
        </p>
        <p class="donation-time">
          {{ donation.datecreated | formatDateRelative }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DonationCard",
  props: {
    donation: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getOrganizationNameFromId: "organization/getOrganizationNameFromId"
    })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
